import { EditorState } from "@common/Common";

export class PortfolioScenarioEditorViewModel
{
    workspaceId: number;
    portfolioId: string;

    state: EditorState = EditorState.Closed;
    corporateScenarioId: string | null = null;
    portfolioScenarioId: string | null = null;

    modalTitle: string | null = null;
    get opened(): boolean { return this.state !== EditorState.Closed; }

    showCreator(workspaceId: number, portfolioId: string, corporateScenarioId: string)
    {
        this.workspaceId = workspaceId;
        this.portfolioId = portfolioId;

        this.corporateScenarioId = corporateScenarioId;
        this.modalTitle = "Create portfolio plan";
        this.state = EditorState.Creator;
    }

    showEditor(workspaceId: number, portfolioId: string, portfolioScenarioId: string)
    {
        this.workspaceId = workspaceId;
        this.portfolioId = portfolioId;

        this.portfolioScenarioId = portfolioScenarioId;
        this.modalTitle = "Edit portfolio plan";
        this.state = EditorState.Editor;
    }

    showCloner(workspaceId: number, portfolioId: string, corporateScenarioId: string, clonedScenarioId: string)
    {
        this.workspaceId = workspaceId;
        this.portfolioId = portfolioId;

        this.corporateScenarioId = corporateScenarioId;
        this.portfolioScenarioId = clonedScenarioId;
        this.modalTitle = "Clone portfolio plan";
        this.state = EditorState.Cloner;
    }

    close()
    {
        this.state = EditorState.Closed;
        this.corporateScenarioId = null;
        this.portfolioScenarioId = null;
    }
}